<vdr-card title="Event stock shortage (이벤트 재고 부족)" style="margin-top: 1rem">
  <div class="form-grid">
    <vdr-form-field
      label="Alert recipients (comma-separated emails)"
      tooltip="Warned when an event closes with not enough stock. Leave empty to disable the alert."
    >
      <input
        type="text"
        [(ngModel)]="alertEmails"
        placeholder="ops@nymusickr.com, stock@nymusickr.com"
      />
    </vdr-form-field>

    <vdr-form-field
      label="Automatically raise a purchase order"
      tooltip="When on, the missing quantity is ordered without waiting for manual approval."
    >
      <clr-toggle-wrapper>
        <input type="checkbox" clrToggle [(ngModel)]="autoPurchase" />
      </clr-toggle-wrapper>
    </vdr-form-field>
  </div>

  <button
    class="btn btn-primary"
    style="margin-top: 0.5rem"
    (click)="save()"
    [disabled]="saving"
  >
    {{ "common.update" | translate }}
  </button>
</vdr-card>
